import React from "react";
import "./about.scss";

const About = ({logo, judul, Deskripsi}) => {
  return (
    <div id="about" className="container-aboutparkspring">
      <div className="logo-aboutparkspring">
        <img className="gambar-logoparkspring" src={logo} alt="Logo" />
      </div>
      <div className="container-deskripsiparkspring">
        <h1>{judul}</h1>
        <div className="deskripsi-aboutparkspring">{Deskripsi}</div>
      </div>
    </div>
  );
};

export default About;
